<template>
  <div class="c-table" ref="planDataTable">
    <el-table
      ref="table"
      border
      show-summary
      class="common-el-table-styles summary-el-table-styles"
      v-loading="loading"
      :height="height"
      :data="data"
      :summary-method="summary"
      @selection-change="select"
      @sort-change="sortChange"
      @header-dragend="headerDragend"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :header-align="col.headerAlign"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'launchTime'">{{ scope.row[col.key] | datetimeToDay }}</span>
          <el-button type="text" v-if="col.key === 'imageName'" @click="$emit('on-show', { key: col.key, row: scope.row })">
            {{ scope.row[col.key] }}
          </el-button>
          <span v-else-if="thousands.includes(col.key)">{{ scope.row[col.key] | toThousands }}</span>

          <span
            v-else-if="
              scope.row[col.key] &&
              (col.key.indexOf('Rate') > -1 ||
                col.key.indexOf('Retain') > -1 ||
                col.key.indexOf('RoleRoi') > -1 ||
                ['createRoleTotalRoi'].includes(col.key))
            "
            >{{ scope.row[col.key] | toPercentFixed }}</span
          >
          <el-popover
            placement="top-start"
            title="达人视频详情"
            :width="getDynamicHeight(scope.row[col.key])"
            trigger="hover"
            v-else-if="col.key === 'darenAwemePlayUrl'"
          >
            <el-badge :value="getImageUrls(scope.row['darenCoverUrl']).length" class="badge-item" type="primary" slot="reference">
              <el-image :src="getImageUrls(scope.row['darenCoverUrl'])[0]" style="height: 120px" fit="contain">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-badge>
            <div class="image-box">
              <div v-for="(item, index) in getImageUrls(scope.row['darenCoverUrl'])" :key="index" class="image-item">
                <img loading="lazy" :src="item" alt="" />
                <el-tag class="preview-btn" @click.stop="previewDouyin(scope.row['darenAwemePlayUrl'], index)">预览</el-tag>
              </div>
            </div>
          </el-popover>
          <span v-else>{{ scope.row[col.key] === null || isEmpty(scope.row[col.key]) ? '-' : scope.row[col.key] }}</span>
        </template>
      </el-table-column>
      <template slot="empty">
        <no-data />
      </template>
    </el-table>
  </div>
</template>
<script>
import { isEmpty } from '@/common/js/utils'
import { thousands } from '../../comprehension-report/js/judge-table.js'

export default {
  name: 'planDataTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Function
    }
  },

  data() {
    return {
      planId: 0,
      modifyVal: 0,
      budgeTmp: 0, // 弹窗预算
      selectList: [],
      thousands
    }
  },
  methods: {
    isEmpty,
    select(val) {
      this.selectList = val
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    headerDragend(n, o, column) {
      this.$emit('header-dragend', { n, o, column })
    },
    getDynamicHeight(urls) {
      const itemUrls = this.getImageUrls(urls)
      return itemUrls.length * 160
    },
    getImageUrls(urls) {
      return urls ? urls.split(',') : ['']
    },
    previewDouyin(urls, index) {
      const previewUrls = this.getImageUrls(urls)
      if (previewUrls.length >= index && previewUrls[index]) {
        window.open(previewUrls[index])
      }
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  background-color: #fff;

  .c-raise-modal {
    .c-raise-body {
      display: flex;
      justify-content: center;
      align-items: center;

      .c-raise-item {
        line-height: 32px;
        padding: 0 10px;
      }
    }
  }

  .dot-inner {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    margin: 0 6px 0 0;
  }

  .tag-disabled .dot-inner {
    background-color: #bfbfbf;
  }

  .tag-success .dot-inner {
    background-color: #09cd8e;
  }

  .tag-warn .dot-inner {
    background-color: #ffa300;
  }

  .tag-error .dot-inner {
    background-color: #f1403c;
  }
}
.image-box {
  overflow: auto;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  .image-item {
    height: 254px;
    background: #eee;
    cursor: pointer;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    width: 143px;
    display: flex;
    align-items: center;
    &:hover {
      opacity: 0.9;
    }

    .preview-btn {
      position: absolute;
      z-index: 1;
      left: 8px;
      top: 8px;
    }
  }
}
img {
  width: 100%;
}
::v-deep .badge-item {
  sup {
    top: 8px;
    right: 16px;
  }
}
</style>
